import { Shape } from 'three';
import { rng } from '../util/rng';

export interface BlobShape {
  shape: Shape;
  minR: number; // минимальный радиус — для вписывания обложки-плиты
}

/**
 * Органическая «кувшинка»-платформа (порт 1:1 из концепта): замкнутый контур из
 * суммы синусоид, лёгкий эллипс. Используется в ExtrudeGeometry (slab) и
 * ShapeGeometry (halo-контур).
 */
export function makeBlobShape(seed: number, R: number): BlobShape {
  const r = rng(seed);
  const pts = 46;
  const a1 = 0.1 + r() * 0.16;
  const a2 = 0.05 + r() * 0.12;
  const a3 = r() * 0.06;
  const p1 = r() * 6.283;
  const p2 = r() * 6.283;
  const p3 = r() * 6.283;
  const ex = 0.86 + r() * 0.34;
  const ey = 0.86 + r() * 0.34;
  const shape = new Shape();
  let minR = Infinity;
  for (let i = 0; i <= pts; i++) {
    const t = (i / pts) * Math.PI * 2;
    const rad = R * (1 + a1 * Math.sin(t * 2 + p1) + a2 * Math.sin(t * 3 + p2) + a3 * Math.sin(t * 5 + p3));
    const x = Math.cos(t) * rad * ex;
    const y = Math.sin(t) * rad * ey;
    const d = Math.hypot(x, y);
    if (d < minR) minR = d;
    if (i === 0) shape.moveTo(x, y);
    else shape.lineTo(x, y);
  }
  shape.closePath();
  return { shape, minR };
}
